// 状态栏高度
import { Platform, StatusBar } from 'react-native';
import { JDNativeSystem } from '@jdreact/jdreact-core-lib';

import isIOS from './isIOS';
import isAndroid from './isAndroid';

let statusBarHeight = 0;

if (isIOS) {
  if (JDNativeSystem.isIPhoneX) {
      JDNativeSystem.statusBarHeight = 34;
  }
  statusBarHeight = JDNativeSystem.statusBarHeight;
} else if (isAndroid && Platform.Version >= 19) {
  statusBarHeight = StatusBar.currentHeight;
}

export default statusBarHeight;
